import { Type } from 'class-transformer';
import { TripItemType } from '@/models/trip/TripItemType';

export class TripItemModel {
  @Type(() => TripItemType)
  public type!: TripItemType;

  public tripVersionId = '';
}
